import React from 'react';

import { Flex, Group, Stack, Text, Title } from '@mantine/core';

interface Props {
    title?: string;
    subtitle?: string;
    rightSection?: React.ReactNode;
    children?: React.ReactNode;
}

export const FullScreenContent = ({ children, ...props }: Props) => {
    return (
        <React.Fragment>
            {props.title && <Header {...props} />}
            {children}
        </React.Fragment>
    );
};

const Header = ({ title, subtitle, rightSection }: Props) => (
    <Flex
        justify="space-between"
        align="center"
        style={(theme) => ({
            flexGrow: 0,
            flexShrink: 0,

            padding: '9px 12px',
            height: 60,
            borderBottom: `1px solid ${theme.colors.gray[3]}`,
        })}
    >
        <Stack gap={0}>
            <Title order={2}>{title}</Title>
            <Text c="dimmed" size="xs">
                {subtitle}
            </Text>
        </Stack>
        <Group gap="xs">
            {rightSection}
            {/* <Button variant="filled" leftSection={<BsGrid3X3GapFill />}>Open</Button> */}
            {/* <Button variant="filled" leftSection={<IoShareOutline />}>Share</Button> */}
            {/* <Button variant="filled" leftSection={<IoArchiveOutline />}>Archive</Button> */}
        </Group>
    </Flex>
);
